import React from 'react';
import { Tooltip, Icon } from 'components';
import InfoTooltip from 'apps/components/InfoTooltip';

interface Tag {
  id?: string;
  label?: string;
}

interface FormFormInfoIconProps {
  id?: string;
  shortDescription?: string;
  tags?: Tag[];
}

const FormInfoIcon = ({
  id,
  tags,
  shortDescription,
}: FormFormInfoIconProps) => {
  const tagsLabels = tags.map(tag => tag.label);

  return (
    <>
      <Icon name='info' data-for={id} data-tip />
      <Tooltip id={id} delayShow={300} place='left'>
        <InfoTooltip description={shortDescription} tags={tagsLabels} />
      </Tooltip>
    </>
  );
};

export default FormInfoIcon;
